import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./disclaimerCard.css";
import getIzProvider, { ProviderKey } from "../../models/providers/IzProviders";
import { DisclaimerStateModal } from "./DisclaimerStateModal";
import { Capacitor } from "@capacitor/core";
import { Dialog } from "@capacitor/dialog";
import { Browser } from "@capacitor/browser";
import i18n from "../../i18n";

interface DisclaimerCardProps {
  provider: ProviderKey;
  screening?: boolean;
}

export default function DisclaimerCard({ provider, screening }: DisclaimerCardProps) {
  const { t } = useTranslation();
  const izProvider = getIzProvider(provider, t);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const mic = "/assets/images/icons_mic.png";
  const micDark = "/assets/images/icons_mic_dark.png";
  const isWeb = Capacitor.getPlatform() === "web";

  const getCardTitleText = () => {
    if (screening) {
      return t("screening.disclaimer_text");
    }
    return t("disclaimer.status", { iisAbbrev: izProvider.iisAbbrev });
  };

  const showDisclaimerModal = async () => {
    if (isWeb) {
      setDisclaimerModal(true);
    } else {
      const { value } = await Dialog.confirm({
        title: t("immunizations.disclaimer_title"),
        message: t(`immunizations.disclaimer_body_${izProvider.jurisdictionAbbrev.toLowerCase()}`),
        okButtonTitle: t("faq.faqs"),
        cancelButtonTitle: t("generic.cancel"),
      });
      if (value) {
        await Browser.open({ url: `https://dockethealth.com/${i18n.language.toLowerCase()}/faqs` });
      }
    }
  };

  return (
    <>
      <div className="flex bg-base-100 mx-4 py-1 mb-2 w-fit text-base-content items-center  rounded-xl">
        <img className="w-10 mx-2 dark:hidden" src={mic} alt="Microphone" />
        <img className="w-10 mx-2 not-dark:hidden" src={micDark} alt="Microphone" />
        <div data-testid="disclaimer-card">
          <span>{getCardTitleText()}</span>
          <button
            className="btn btn-link text-primary pl-1 text-base my-0 h-fit"
            onClick={showDisclaimerModal}
          >
            {t("disclaimer.learn_more")}
          </button>
        </div>
      </div>
      {disclaimerModal && (
        <DisclaimerStateModal
          closeModal={() => setDisclaimerModal(false)}
          stateCode={izProvider.jurisdictionAbbrev.toLowerCase()}
          screening={screening}
        />
      )}
    </>
  );
}
